// import _404 from "components/_404";
import RequiredAuth from "utils/RequiredAuth";
import lazy from "utils/lazy";
import { RouteConstants } from "./RouteConstants";

const Home = lazy(() =>
  import(/* webpackChunkName: "Home" */ "modules/home/pages/")
);

const Details = lazy(() =>
  import(
    /* webpackChunkName: "Details" */ "modules/billingSubscriptions/pages/Details"
  )
);

const ComingSoon = lazy(() =>
  import(/* webpackChunkName: "ComingSoon" */ "components/ComingSoon")
);

//Old Auth Flow

// const VerifyUser = lazy(() =>
//   import(
//     /* webpackChunkName: "freeTrialSignUp" */ "modules/Login/pages/VerifyUser"
//   )
// );

// const Login = lazy(() =>
//   import(/* webpackChunkName: "Login" */ "modules/Login/pages/index")
// );

// // const Register = lazy(() =>
// //   import(/* webpackChunkName: "Register" */ "modules/Login/pages/signup")
// // );

// const ForgotPassword = lazy(() =>
//   import(
//     /* webpackChunkName: "ForgotPassword" */ "modules/Login/pages/ForgotPassword"
//   )
// );

// const ResetPassword = lazy(() =>
//   import(
//     /* webpackChunkName: "ResetPassword" */ "modules/Login/pages/ResetPassword"
//   )
// );

// const ResetPasswordOtp = lazy(() =>
//   import(
//     /* webpackChunkName: "ResetPasswordOtp" */ "modules/Login/pages/ResetPasswordOtp"
//   )
// );

// New Flow

const VerifyUser = lazy(() =>
  import(
    /* webpackChunkName: "VerifyUser" */ "modules/authentication/pages/UserConformation"
  )
);
const ResendLink = lazy(() =>
  import(
    /* webpackChunkName: "ResendLink" */ "modules/authentication/pages/ResendLink"
  )
);
const Login = lazy(() =>
  import(/* webpackChunkName: "Login" */ "modules/authentication/pages/Login")
);
const Register = lazy(() =>
  import(
    /* webpackChunkName: "Register" */ "modules/authentication/pages/Register"
  )
);
const ConfirmUrl = lazy(() =>
  import(
    /* webpackChunkName: "ConfirmUrl" */ "modules/authentication/pages/Conformation"
  )
);
const ForgetPassword = lazy(() =>
  import(
    /* webpackChunkName: "ForgetPassword" */ "modules/authentication/pages/ForgetPassword"
  )
);
const ResetPassword = lazy(() =>
  import(
    /* webpackChunkName: "freeTrialSignUp" */ "modules/authentication/pages/ResetPassword"
  )
);

//Other Flow

const viewOrder = lazy(() =>
  import(
    /* webpackChunkName: "Register" */ "modules/billingSubscriptions/pages/Order"
  )
);

// const Checkout = lazy(() =>
//   import(/* webpackChunkName: "Checkout" */ "modules/old-checkout/pages")
// );

const ResetPasswordSecurityQuestion = lazy(() =>
  import(
    /* webpackChunkName: "SecurityQuestion" */ "modules/Login/pages/ResetPasswordSecurityQue"
  )
);

const FreeTrialSignUp = lazy(() =>
  import(
    /* webpackChunkName: "freeTrialSignUp" */ "modules/Login/pages/FreeTrialSignUp"
  )
);

const SubscriptionConfirmation = lazy(() =>
  import(
    /* webpackChunkName: "SubscriptionConfirmation" */ "modules/checkout/pages/SubscriptionConformation"
  )
);

const CurriculumSubscription = lazy(() =>
  import(
    /* webpackChunkName: "SubscriptionConfirmation" */ "modules/checkout/pages/CurriculumSubscription"
  )
);

const Checkout = lazy(() =>
  import(/* webpackChunkName: "Checkout" */ "modules/checkout/pages/Checkout")
);

const OrderConformationReceipt = lazy(() =>
  import(
    /* webpackChunkName: "Checkout" */ "modules/checkout/components/ConformationReceipt"
  )
);

const AcceptInvitation = lazy(() =>
  import(
    /* webpackChunkName: "AcceptInvitation" */ "modules/authentication/pages/Invitation"
  )
);

const ShippingConformation = lazy(() =>
  import(
    /* webpackChunkName: "ShippingConformation" */ "modules/shippingConformation"
  )
);

const InvoiceComponent = lazy(() =>
  import(/* webpackChunkName: "InvoiceComponent" */ "modules/invoice/index.")
);

const routesConfig = {
  common: [
    {
      path: RouteConstants.subscriptionConfirmation,
      component: SubscriptionConfirmation,
    },
    {
      path: RouteConstants.CurriculumSubsctiption,
      component: CurriculumSubscription,
    },
    {
      path: RouteConstants.checkout,
      component: Checkout,
    },
    {
      path: RouteConstants.acceptInvitation,
      component: AcceptInvitation,
    },
    {
      path: RouteConstants.ShippingConfirmation,
      component: ShippingConformation,
    },
    {
      path: RouteConstants.OldShippingConfirmation,
      component: ShippingConformation,
    },
    {
      path: RouteConstants.invoice,
      component: InvoiceComponent,
    },
  ],
  private: [
    {
      path: RouteConstants.home,
      component: Home,
    },
    {
      path: RouteConstants.viewSubscription,
      component: Details,
    },

    {
      path: RouteConstants.viewOrder,
      component: viewOrder,
    },

    { path: RouteConstants.comingSoon, component: ComingSoon },
    {
      path: RouteConstants.orderConformationReceipt,
      component: OrderConformationReceipt,
    },
  ],
  public: [
    {
      path: "*",
      component: RequiredAuth,
    },

    {
      path: RouteConstants.home,
      component: VerifyUser,
    },
    {
      path: RouteConstants.resendLink,
      component: ResendLink,
    },
    {
      path: RouteConstants.login,
      component: Login,
    },
    {
      path: RouteConstants.signup,
      component: Register,
    },
    {
      path: RouteConstants.confirmLink,
      component: ConfirmUrl,
    },
    {
      path: RouteConstants.forgetPassword,
      component: ForgetPassword,
    },
    {
      path: RouteConstants.resetPassword,
      component: ResetPassword,
    },

    // { path: RouteConstants.forgotPassword, component: ForgotPassword },
    // { path: RouteConstants.resetPassword, component: ResetPassword },
    // { path: RouteConstants.resetPasswordOtp, component: ResetPasswordOtp },

    // {
    //   path: RouteConstants.home,
    //   component: VerifyUser,
    // },
    // {
    //   path: RouteConstants.login,
    //   component: Login,
    // },
    // {
    //   path: RouteConstants.signup,
    //   // component: Register,
    //   component: FreeTrialSignUp,
    // },
    // { path: RouteConstants.forgotPassword, component: ForgotPassword },
    // { path: RouteConstants.resetPassword, component: ResetPassword },
    // { path: RouteConstants.resetPasswordOtp, component: ResetPasswordOtp },
    {
      path: RouteConstants.resetPasswordSecurityQuestion,
      component: ResetPasswordSecurityQuestion,
    },

    {
      path: RouteConstants.freetrialsignup,
      component: FreeTrialSignUp,
    },
  ],
};

export default routesConfig;
